
import * as React from 'react';


const HappyFace = ({
  style,
  className,
  size = '30px',
  color = '#333' }) => /*#__PURE__*/

React.createElement("svg", {
  fill: "none",
  width: size,
  height: size,
  style: style,
  viewBox: "0 0 30 31",
  className: className,
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement("path", {
  d: "M15.75 5.54037C21.4938 5.54037 26.15 10.1966 26.15 15.9404C26.15 21.6841 21.4938 26.3404 15.75 26.3404C10.0062 26.3404 5.35 21.6841 5.35 15.9404C5.35 10.1966 10.0062 5.54037 15.75 5.54037ZM28.75 15.9404C28.75 8.76067 22.9297 2.94037 15.75 2.94037C8.5703 2.94037 2.75 8.76067 2.75 15.9404C2.75 23.1201 8.5703 28.9404 15.75 28.9404C22.9297 28.9404 28.75 23.1201 28.75 15.9404Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M18.35 12.6904C18.35 13.7673 19.223 14.6404 20.3 14.6404C21.377 14.6404 22.25 13.7673 22.25 12.6904C22.25 11.6134 21.377 10.7404 20.3 10.7404C19.223 10.7404 18.35 11.6134 18.35 12.6904Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M9.25 12.6904C9.25 13.7673 10.123 14.6404 11.2 14.6404C12.277 14.6404 13.15 13.7673 13.15 12.6904C13.15 11.6134 12.277 10.7404 11.2 10.7404C10.123 10.7404 9.25 11.6134 9.25 12.6904Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M20.5792 20.4076C21.5706 19.3571 22.0566 18.1742 22.2112 17.5557L19.6888 16.9251C19.6268 17.1732 19.3327 17.9403 18.6883 18.6231C18.0789 19.2689 17.1614 19.8404 15.75 19.8404C14.3386 19.8404 13.4212 19.2689 12.8117 18.6231C12.1673 17.9403 11.8732 17.1732 11.8112 16.9251L9.28883 17.5557C9.44346 18.1742 9.9294 19.3571 10.9208 20.4076C11.9472 21.4952 13.5214 22.4404 15.75 22.4404C17.9786 22.4404 19.5528 21.4952 20.5792 20.4076Z",
  fill: color }));




export default HappyFace;